/**
 * 실시간 반영: 서버가 일정 변경을 SSE(/calendar/stream)로 흘려주면, 다른
 * 탭·사용자의 변경을 조용한 갱신으로 가져온다. 자기 탭의 에코(origin)는
 * 무시하고, 갱신은 편집·드래그·마우스 오버 중이면 미뤄진다.
 */
import { CLIENT_ID, remoteChanged } from './calendar-history.js';

// 어느 캘린더의 스트림인가: 허브(#projHub) 또는 뷰 데이터 섬의 범위(허브의 월·보드·시간표 뷰는 #projHub 가
// 없다), 빈 값 = /calendar 오버레이. 뷰 탭이 있는 화면이면 종류와 무관하게 붙는다 (뷰 변경 SSE, AQ7).
function streamCalendarId() {
    const hub = document.getElementById('projHub');
    if (hub) return hub.dataset.calId || '';
    const island = document.getElementById('calViewData');
    try { return ((JSON.parse(island ? island.textContent : '{}') || {}).scope || {}).calendarId || ''; } catch (_) { return ''; }
}

export function setupCalendarLive() {
    if (!document.getElementById('projHub') && !document.getElementById('calGrid') && !document.getElementById('calViewTabs')) return;
    if (typeof EventSource === 'undefined') return;
    const calId = streamCalendarId();
    const url = '/calendar/stream' + (calId ? '?calendar=' + encodeURIComponent(calId) : '');
    let es = null;
    let retry = 2000;
    function connect() {
        es = new EventSource(url, { withCredentials: true });
        es.addEventListener('change', (e) => {
            let msg = null;
            try { msg = JSON.parse(e.data); } catch (_) { return; }
            if (!msg || msg.origin === CLIENT_ID) return;
            remoteChanged();
            document.dispatchEvent(new CustomEvent('calendar:remote-change', { detail: msg }));
        });
        es.onopen = () => { retry = 2000; };
        es.onerror = () => {
            es.close();
            setTimeout(connect, retry);
            retry = Math.min(retry * 2, 30000);
        };
    }
    connect();
    window.addEventListener('pagehide', () => { if (es) es.close(); });
}
